module.exports = __webpack_public_path__ + "img/20191230160106360截图20191230104946390.2554c13c.jpg";